export default __webpack_public_path__ + "static/media/email-dashboard-icon-selected.3dbdd3d1.svg";